import { useKeycloak } from "@react-keycloak/web";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
//import img_expertiseherocover from "../../images/expertise-hero-cover.svg"
import img_expertiseherocover from "../../images/editeurspros_cover.svg"
import img_rond from "../../images/service-electre-illu.svg"
import "./PageBOPresentation.scss"
import { useSelector } from "react-redux";
import { RootState } from "../../redux/store";
import CpntBlocPresentation from "../../components/CpntBlocPresentation";


const PageBOPresentation = () => {


  const navigate = useNavigate();
  const { keycloak } = useKeycloak();
  const compte = useSelector((state: RootState) => state.compte);

  useEffect(() => {
    if (keycloak.authenticated && compte?.Connected) {
      navigate("/accueil");
    }
  }, [keycloak.authenticated,compte])
  
    
   return (
    <>
      <div className="App-body-BO-Deconnecte">
          <div className="container-fluid text-center mb-5">
            <div className="col-xl-8 offset-xl-2 col-lg-2">
            <img src={img_expertiseherocover} alt="" className="expertiseherocover " />  {/* d-block d-xl-none */}
            </div>
            <div className="row pt-3 pb-5">
            <div className="col col-md-10 offset-md-1 col-12 mb-5">
              <div className="titre titre-Presentation text-center">Editeurs <span className="word">Pros</span></div>
              <div className="description-Titre text-center"><b>Un espace dédié à la gestion de votre catalogue sur electre.com</b></div>
            </div>
          </div>
          <CpntBlocPresentation
            titre=" Back Office Electre "
            description="Accéder au Back Office Electre en cliquant sur &quot;Connexion&quot;"
            img_gauche={true}
            img_rond={img_rond}
            />
          </div>
        </div>
     </>
  );
};

export default PageBOPresentation;
